import { forwardRef } from "react";
import { cn } from "../lib/cn";

export interface BoxProps extends React.HTMLAttributes<HTMLDivElement> {
  /** Semantic element to render instead of a div. */
  as?:
    | "div"
    | "section"
    | "article"
    | "header"
    | "footer"
    | "nav"
    | "main"
    | "aside"
    | "span";
  children?: React.ReactNode;
}

/**
 * Polymorphic layout primitive (replaces MUI Box). No sx-style prop
 * translation — callers pass Tailwind utility classes via `className`.
 */
export const Box = forwardRef<HTMLDivElement, BoxProps>(
  ({ as = "div", className, ...props }, ref) => {
    const Component: React.ElementType = as;
    return <Component ref={ref} className={cn(className)} {...props} />;
  },
);
Box.displayName = "Box";
